import {Table} from "./Table";
import {Select} from "./Select";
import {TextField} from "./TextField";
import React, {useEffect, useState} from "react";
import {OrderPaidProduct, ProductSize} from "../types/types";
import {getProductSizes} from "../apis/products";
import { sortedSizeObjects } from "../utils/sortedSizes";

type ExchangeProductItemProps = {
    product: OrderPaidProduct
    isMobile?: boolean
    onExchangeSize: (sizeId: number) => void
    onExchangeReason: (reason: string) => void
}

const ExchangeProductItem = (props: ExchangeProductItemProps) => {
    const {product, isMobile, onExchangeSize, onExchangeReason} = props;
    const [reasonType, setReasonType] = useState<string | undefined>();
    const [sizes, setSizes] = useState<ProductSize[]>([]);

    useEffect(() => {
        getProductSizes(product.productId).then(r => setSizes(r.data.payload));
    }, [])

    const currentSizesStocks = (list: ProductSize[]) => {
        const stocksList = list.filter((item) => item.currentStock > 0)
        if (stocksList.length === 0) {
            return '없음'
        } else {
            return sortedSizeObjects(stocksList, 'sizeName').map((item) => item.sizeName).join(', ')
        }
    }

    if (isMobile) {
        return (
            <div className="flex justify-between items-center border-b pb-4">
                <div className="flex space-x-4 font-normal items-center">
                    <div className="w-20 h-28 relative rounded-md overflow-hidden">
                        <img
                            src={product.thumbnailUrl}
                            alt=""
                            className="w-full h-full object-cover absolute"
                        />
                    </div>

                    <div className="space-y-2 text-10 font-semibold">
                        <p className="whitespace-normal">{product.productName}</p>
                        <span className="text-brand-3">{product.color}</span>

                        <p className="text-brand-3">{product.unitPrice.toLocaleString()}원/수량{product.count}개</p>
                    </div>
                </div>

                <div>
                    <Select
                        className="border pl-2 border-gray-200"
                        defaultValue={"교환사유"}
                        onChange={(e) => setReasonType(e.target.value)}
                    >
                        <option disabled hidden>교환사유</option>
                        <option value="1">사이즈 변경</option>
                        <option value="2">기타사유</option>
                    </Select>
                    {reasonType === '1' && (
                        <div className="space-y-3">
                            <Select
                                className="border border-gray-100 pl-4"
                                onChange={(e) => onExchangeSize(parseInt(e.target.value))}
                            >
                                <option hidden={true} value={product.sizeName}>{product.sizeName}</option>
                                {sizes.map((item, index) => {
                                    if (item.currentStock > 0) return <option key={index}
                                                                              selected={product.sizeName === item.sizeName}
                                                                              hidden={product.sizeName === item.sizeName}
                                                                              value={item.productSizeId}>{item.sizeName}</option>
                                })}
                            </Select>
                            <p className="text-13 text-red-500 font-normal">
                                남은 사이즈 : {currentSizesStocks(sizes)}
                            </p>
                        </div>
                    )}
                    {reasonType === '2' && (
                        <TextField className="border-gray-100"
                                   placeholder={`사유를 입력해주세요.`}
                                   onChange={(e) => onExchangeReason(e.target.value)}
                        />
                    )}
                </div>
            </div>
        )
    } else {
        return (
            <Table.Row>
                <Table.Td>
                    <div className="flex space-x-4 font-normal items-center">
                        <div className="w-20 h-28 relative rounded-md overflow-hidden">
                            <img
                                src={product.thumbnailUrl}
                                alt=""
                                className="w-full h-full object-cover absolute"
                            />
                        </div>
                        <div className="space-y-2 text-10 font-semibold">
                            <p className="whitespace-normal">
                                {product.productName}
                                <br/>
                                <span className="text-brand-3">{product.color}</span>
                            </p>

                            <p className="text-brand-3">{product.discountedUnitPrice.toLocaleString()}원/수량 {product.count}개</p>
                        </div>
                    </div>
                </Table.Td>

                <Table.Td>
                    <div className="space-y-2">
                        <Select
                            className="border border-gray-100 pl-4"
                            defaultValue={"교환사유"}
                            onChange={(e) => setReasonType(e.target.value)}
                        >
                            <option disabled hidden>교환사유</option>
                            <option value="1">사이즈 변경</option>
                            <option value="2">기타사유</option>
                        </Select>

                        {reasonType === '1' && (
                            <div className="space-y-3">
                                <Select
                                    className="border border-gray-100 pl-4"
                                    onChange={(e) => onExchangeSize(parseInt(e.target.value))}
                                >
                                    <option hidden={true} value={product.sizeName}>{product.sizeName}</option>
                                    {sortedSizeObjects(sizes, 'sizeName').map((item, index) => {
                                        if (item.currentStock > 0) return <option key={index}
                                                                                  selected={product.sizeName === item.sizeName}
                                                                                  hidden={product.sizeName === item.sizeName}
                                                                                  value={item.productSizeId}>{item.sizeName}</option>
                                    })}
                                </Select>
                                <p className="text-13 text-red-500 font-normal">
                                    남은 사이즈 : {currentSizesStocks(sizes)}
                                </p>
                            </div>
                        )}
                        {reasonType === '2' && (
                            <TextField className="border-gray-100"
                                       placeholder={`사유를 입력해주세요.`}
                                       onChange={(e) => onExchangeReason(e.target.value)}
                            />
                        )}
                    </div>
                </Table.Td>
            </Table.Row>
        )
    }
}

export default ExchangeProductItem;